import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Generate a stable per-browser device fingerprint and attach it to every
// request — used by the backend for login_history + audit logging.
function getDeviceFingerprint() {
  try {
    let fp = localStorage.getItem("rx_device");
    if (!fp) {
      fp = `dev-${Math.random().toString(36).slice(2)}${Date.now().toString(36)}`;
      localStorage.setItem("rx_device", fp);
    }
    return fp;
  } catch { return ""; }
}

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  const fp = getDeviceFingerprint();
  if (fp) config.headers["X-Device-Fingerprint"] = fp;
  return config;
});

export const API_URL = API;

export function formatApiError(err) {
  const detail = err?.response?.data?.detail;
  if (!detail) return err?.message || "Something went wrong";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  if (detail?.msg) return detail.msg;
  return String(detail);
}
